/**
 * The account an access token belongs to: `userId` in its payload (else `sub` / `id`). Null when
 * there is no token or it cannot be read. Used to keep per-player things on a shared device apart.
 */
export function accountIdFromToken(token: string | null | undefined): string | null {
  try {
    const payload = token?.split('.')[1];
    if (!payload) return null;
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as {
      userId?: unknown;
      sub?: unknown;
      id?: unknown;
    };
    const id = json.userId ?? json.sub ?? json.id;
    return id == null || id === '' ? null : String(id);
  } catch {
    return null;
  }
}
